<template>
  <main class="c-section--panel-courses py-2">
    <h1 class="fs-21 w-bold darks mb-3">Mis cursos</h1>

    <div class="c-navigator bg-white px-3 br--small mb-4">
      <nav class="c-navigator__items d-flex">
        <router-link
          to="/"
          class="c-navigator-item py-2 d-flex position-relative"
          :class="isActive('main')">
          <p class="c-navigator-item__title w-sbold mb-0">Cursos</p>
        </router-link>
        <router-link
          to="/?type=hide"
          class="c-navigator-item py-2 d-flex position-relative"
          :class="isActive('hide')">
          <p class="c-navigator-item__title w-sbold mb-0">Ocultos</p>
        </router-link>
      </nav>
    </div>

    <div class="c-header-courses mb-4">
      <div class="c-form">
        <div class="row no-gutters justify-content-end">
          <div class="col col-12 col-md-6 mb-3 col-lg-auto mb-md-0">
            <div class="">
              <input
                @keyup.enter="search()"
                v-model="filterData.search"
                :disabled="courses.loading || specialities.loading"
                type="search"
                class="c-form__input c-form__input--search tiny"
                :class="{'filled' : filterData.search}"
                placeholder="Buscar un curso">
            </div>
          </div>
          <div v-if="$route.query.type !== 'hide'" class="col col-12 col-md-6 col-lg-auto">
            <select
              v-model="filterData.type"
              :disabled="courses.loading || specialities.loading"
              class="c-form__select tiny"
            >
              <option value="all">Todos</option>
              <option
                v-for="option of filterOptions"
                :key="option.id"
                :value="option.id"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div v-if="noWorkProfile && $route.query.connecta" class="mb-5">
      <WelcomeConecta />
    </div>

    <section class="c-specialities mb-5">
      <div class="d-flex justify-content-between align-items-start">
        <div class="mb-4">
          <h2 class="w-bold fs-21 mb-1">Especialidades</h2>

          <b-skeleton-wrapper :loading="specialities.loading">
            <template #loading>
              <b-skeleton
                no-aspect
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
            </template>

            <p class="mb-0 w-sbold fs-14">{{ specialities.total }} resultados</p>
          </b-skeleton-wrapper>
        </div>

        <div v-if="false" class="d-flex align-items-center">
          <button class="c-specialities__prev c-link c-link--primary swiper-button-disabled"
          >
            <i class="iconf-arrow-left d-flex align-items-center"></i>
          </button>
          <div class="mx-2 mx-md-3">
            <div id="specialities-fraction" class="c-specialities__fraction"></div>
          </div>
          <button class="c-specialities__next c-link c-link--primary"
          >
            <i class="iconf-arrow-right d-flex align-items-center"></i>
          </button>
        </div>
      </div>

      <section>
        <b-skeleton-wrapper :loading="specialities.loading">
          <template #loading>
            <div class="c-courses-grid">
              <div
                v-for="item of Array.from(Array(rowsLoading).keys())"
                :key="`speciality-skeleton-${item}`"
                class="c-courses-grid__item"
              >
                <div class="br--medium overflow-hidden">
                  <b-skeleton
                    no-aspect
                    height="300px"
                    animation="fade"
                    class="light mb-2"
                  ></b-skeleton>
                </div>
              </div>
            </div>
          </template>

          <div
            v-if="specialities.isEmpty"
            class="bg-white br--small p-3 py-md-4 text-center w-100">
            <p class="mb-3 w-medium">{{specialityEmptyMessage.description}}</p>
            <a
              v-if="!specialityEmptyMessage.intern"
              href="/es/cursos/etiqueta/pack"
              class="c-button c-button--primary medium d-inline-block">
              Explorar especialidades
            </a>
            <router-link
              v-else
              to="/"
              class="c-link d-inline-block">
              <i class="iconf-left-arrow me-2"></i>
              Volver a mis cursos
            </router-link>
          </div>
          <section v-else>
            <div class="c-courses-grid mb-5">
              <div
                v-for="speciality of specialities.data"
                :key="speciality.id"
                class="c-courses-grid__item">
                <SpecialityCard
                  :body="speciality"
                  :user="userData"
                  :list.sync="specialities.data"
                  :total.sync="specialities.total"
                  :empty.sync="specialities.isEmpty"
                />
              </div>
            </div>

            <div
              v-if="specialities.page !== -1"
              class="d-flex justify-content-center">
              <button
                @click="getSpecialities()"
                class="c-button c-button--primary"
                :class="{'loading' : specialities.loadingButton}"
                :disabled="specialities.loadingButton"
              >
                Ver más especialidades
                <img
                  class="c-button__spinner"
                  src="../../assets/images/animations/spinner-white.png"
                  alt="loading"
                />
              </button>
            </div>
          </section>
        </b-skeleton-wrapper>
      </section>
    </section>

    <section>
      <div class="d-flex">
        <div class="mb-4">
          <h2 class="w-bold fs-21 mb-1">Cursos cortos</h2>

          <b-skeleton-wrapper :loading="courses.loading">
            <template #loading>
              <b-skeleton
                no-aspect
                animation="fade"
                class="light mb-2"
              ></b-skeleton>
            </template>

            <p class="mb-0 w-sbold fs-14">{{ courses.total }} resultados</p>
          </b-skeleton-wrapper>
        </div>
      </div>

      <b-skeleton-wrapper :loading="courses.loading">
        <template #loading>
          <div class="c-courses-grid">
            <div
              v-for="item of Array.from(Array(rowsLoading).keys())"
              :key="`course-skeleton-${item}`"
              class="c-courses-grid__item"
            >
              <div class="br--medium overflow-hidden">
                <b-skeleton
                  no-aspect
                  height="300px"
                  animation="fade"
                  class="light mb-2"
                ></b-skeleton>
              </div>
            </div>
          </div>
        </template>

        <div v-if="courses.isEmpty"  class="bg-white br--small p-3 py-md-4 text-center w-100">
          <p class="mb-3 w-medium">{{courseEmptyMessage.description}}</p>
          <a
            v-if="!courseEmptyMessage.intern"
            href="/es/cursos"
            class="c-button c-button--primary medium d-inline-block">
            Explorar cursos
          </a>
          <router-link
            v-else
            to="/"
            class="c-link d-inline-block">
            <i class="iconf-left-arrow me-2"></i>
            Volver a mis cursos
          </router-link>
        </div>
        <section v-else>
          <div class="c-courses-grid mb-5">
            <div v-for="course of courses.data" :key="course.id" class="c-courses-grid__item">
              <CourseCard
                :body="course"
                :user="userData"
                :list.sync="courses.data"
                :total.sync="courses.total"
                :empty.sync="courses.isEmpty" />
            </div>
          </div>

          <div
            v-if="courses.page !== -1"
            class="d-flex justify-content-center">
            <button
              @click="getCourses()"
              class="c-button c-button--primary"
              :class="{'loading' : courses.loadingButton}"
              :disabled="courses.loadingButton"
            >
              Ver más cursos
              <img
                class="c-button__spinner"
                src="../../assets/images/animations/spinner-white.png"
                alt="loading"
              />
            </button>
          </div>
        </section>
      </b-skeleton-wrapper>
    </section>

    <ModalFillProfile v-if="userData && userData.id" :user="userData" />
    <WelcomeKits v-if="userData && userData.id" :user="userData" />
  </main>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      rows: 1,
      rowsLoading: 3,

      filterOptions: [
        {
          id: 'start',
          label: 'Por empezar',
        },
        {
          id: 'progress',
          label: 'En progreso',
        },
        {
          id: 'completed',
          label: 'Completados',
        },
      ],
      filterData: {
        search: '',
        type: 'all',
      },

      specialities: {
        total: 0,
        data: [],
        isEmpty: false,

        page: 1,
        slider: null,
        loading: true,
        loadingButton: false,
      },
      courses: {
        total: 0,
        data: [],
        isEmpty: false,

        page: 1,
        slider: null,
        loading: true,
        loadingButton: false,
      },
    };
  },
  components: {
    SpecialityCard: () => import(/* webpackChunkName: "speciality-card-player" */'../../components/panel/SpecialityCard.vue'),
    CourseCard: () => import(/* webpackChunkName: "course-card-player" */'../../components/panel/CourseCard.vue'),
    ModalFillProfile: () => import(/* webpackChunkName: "modal-fill-profile" */'../../components/panel/ModalFillProfile.vue'),
    WelcomeKits: () => import(/* webpackChunkName: "welcome-kits" */'../../components/panel/WelcomeKits.vue'),
    WelcomeConecta: () => import(/* webpackChunkName: "welcome-conecta" */'../../components/panel/WelcomeConecta.vue'),
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),

    filterQueries() {
      let queries = '';

      if (this.$route.query.search) {
        queries += `&s=${this.$route.query.search}`;
      }

      if (this.$route.query.type) {
        queries += (this.$route.query.type === 'hide')
          ? '&hide=1'
          : `&fstatus=${this.$route.query.type}`;
      }

      return queries;
    },

    courseEmptyMessage() {
      let mode = '';

      if (this.$route.query.type) {
        if (this.$route.query.type === 'hide') mode = 'oculto';
        else if (this.$route.query.type === 'start') mode = 'por empezar';
        else if (this.$route.query.type === 'progress') mode = 'en progreso';
        else if (this.$route.query.type === 'completed') mode = 'completado';
      }

      return {
        description: `Aun no cuentas con algun curso ${mode}`,
        intern: mode,
      };
    },
    specialityEmptyMessage() {
      let mode = '';

      if (this.$route.query.type) {
        if (this.$route.query.type === 'hide') mode = 'oculta';
        else if (this.$route.query.type === 'start') mode = 'por empezar';
        else if (this.$route.query.type === 'progress') mode = 'en progreso';
        else if (this.$route.query.type === 'completed') mode = 'completada';
      }

      return {
        description: `Aun no cuentas con alguna especialidad ${mode}`,
        intern: mode,
      };
    },

    noWorkProfile() {
      return this.userData.workProfile
        && !this.userData.workProfile.loading
        && !this.userData.workProfile.data;
    },
  },
  watch: {
    userData(data) {
      this.user = data;
    },

    'filterData.search': function clear(value) {
      if (!value) {
        this.filterData.search = '';

        this.$router.push({
          path: '/',
          ...((this.$route.query.type) && { query: { type: this.$route.query.type } }),
        });
      }
    },

    'filterData.type': function filter(value) {
      this.$router.push({
        path: '/',
        query: {
          ...((value !== 'all') && { type: value }),
        },
      });
    },
  },
  mounted() {
    this.user = this.userData;

    if (this.$route.query.search) this.filterData.search = this.$route.query.search;
    if (this.$route.query.type && this.$route.query.type !== 'hide') {
      this.filterData.type = this.$route.query.type;
    }

    this.getContent();

    this.initListenGrid();
  },
  methods: {
    initListenGrid() {
      window.setTimeout(() => {
        const gap = 32;
        const minW = 256;

        let Wc = document.querySelector('.c-courses-grid').offsetWidth;
        let N = Math.floor((Wc + gap) / (minW + gap));

        this.rowsLoading = N;

        window.addEventListener('resize', () => {
          Wc = document.querySelector('.c-courses-grid').offsetWidth;
          N = Math.floor((Wc + gap) / (minW + gap));

          this.rowsLoading = N;
        });
      }, 1000);
    },

    isActive(section) {
      let className = '';

      if (this.$route.query.type) {
        className = (this.$route.query.type === section) ? 'active' : '';
      } else {
        className = (section === 'main') ? 'active' : '';
      }

      return className;
    },

    getCoursesREST(type) {
      const page = (type === 'courses') ? this.courses.page : this.specialities.page;
      let request = '';
      let perPage = 0;

      if (type === 'courses') {
        perPage = (this.rows > 3) ? this.rows * 2 : 6;
      } else {
        perPage = (this.rows > 3) ? this.rows : 3;
      }

      request = `${window.arcux.api}/profile/${this.user.id}/${type}/?paged=${page}&perPage=${perPage}${this.filterQueries}`;

      return request;
    },
    getCourses() {
      const request = this.getCoursesREST('courses');

      if (this.courses.page === 1) {
        this.courses.loading = true;
      } else {
        this.courses.loadingButton = true;
      }

      this.courses.isEmpty = false;

      fetch(request, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status && response.data.data.length) {
            this.courses.data = (response.data.paged === 1)
              ? response.data.data
              : this.courses.data.concat(response.data.data);

            this.courses.total = response.data.total;

            this.courses.loadingButton = false;
            this.courses.page += 1;
            this.courses.loading = false;
          } else {
            if (!this.courses.data.length) {
              this.courses.isEmpty = true;
              this.courses.total = 0;
            }

            this.courses.page = -1;
            this.courses.loading = false;
          }
        })
        .catch(() => {
          if (!this.courses.data.length) {
            this.courses.isEmpty = true;
            this.courses.total = 0;
          }

          this.courses.page = -1;
          this.courses.loading = false;
        });
    },
    getSpecialities() {
      const request = this.getCoursesREST('specialities');

      if (this.specialities.page === 1) {
        this.specialities.loading = true;
      } else {
        this.specialities.loadingButton = true;
      }

      this.specialities.isEmpty = false;

      fetch(request, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status && response.data.data.length) {
            this.specialities.data = (response.data.paged === 1)
              ? response.data.data
              : this.specialities.data.concat(response.data.data);

            this.specialities.total = response.data.total;

            this.specialities.loadingButton = false;
            this.specialities.page += 1;
            this.specialities.loading = false;
          } else {
            if (!this.specialities.data.length) {
              this.specialities.total = 0;
              this.specialities.isEmpty = true;
            }

            this.specialities.page = -1;
            this.specialities.loading = false;
          }
        })
        .catch(() => {
          if (!this.specialities.data.length) {
            this.specialities.total = 0;
            this.specialities.isEmpty = true;
          }

          this.specialities.page = -1;
          this.specialities.loading = false;
        });
    },
    getContent() {
      this.specialities = {
        ...this.specialities,
        total: 0,
        page: 1,
        data: [],
      };

      this.courses = {
        ...this.courses,
        total: 0,
        page: 1,
        data: [],
      };

      if (this.user && this.user.id) {
        this.getCourses();
        this.getSpecialities();
      }
    },

    search() {
      if (this.filterData.search.trim()) {
        this.$router.push({
          path: '/',
          query: {
            ...((this.$route.query.type) && { type: this.$route.query.type }),
            search: this.filterData.search,
          },
        });
      }
    },
  },
};
</script>
